module.exports = __webpack_public_path__ + "img/aai.790d9f53.png";